"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigMapSchema = exports.ConfigError = exports.ConfigCollection = exports.ConfigClient = void 0;
var client_1 = require("./client");
Object.defineProperty(exports, "ConfigClient", { enumerable: true, get: function () { return client_1.ConfigClient; } });
var js_config_common_1 = require("@atlassian/js-config-common");
Object.defineProperty(exports, "ConfigCollection", { enumerable: true, get: function () { return js_config_common_1.ConfigCollection; } });
Object.defineProperty(exports, "ConfigError", { enumerable: true, get: function () { return js_config_common_1.ConfigError; } });
Object.defineProperty(exports, "ConfigMapSchema", { enumerable: true, get: function () { return js_config_common_1.ConfigMapSchema; } });
